// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ta .edit-user-actions .spinner {
  margin: 0 auto;
}
.error .errorDisplay {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.error .errorDisplay .okButtonContainer {
  margin-top: 2rem;
  width: 12rem;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  align-items: center;
}

.error .errorImageContainer {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
}

.docDeleteError {
  color: red;
  width: 98%;
  font-size: 15px;
  font-weight: bold;
  padding: 10px 10px 10px 10px;
  margin-bottom: 15px;
  margin-top: 20px;
  background-color: white;
}
#viewDeleteDocumentsModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tr
  th
  button {
  background-color: #dfdfdf;
  border: 1px #dedede;
  font-weight: bold;
}
/*.ta .content-block .table-block .table button {
    background-color: #ddd !important;
}*/
.docdelete-success {
  margin: 26px 0px 0px 0px;
  font-size: 15px;
}

#viewDeleteDocumentsModal .btn-cancel-action {
  text-decoration: underline;
  color: #76757a;
  margin-right: 15px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/management/documents.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;;;;;;EAQE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE;AACF;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".ta .edit-user-actions .spinner {\n  margin: 0 auto;\n}\n.error .errorDisplay {\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n\n.error .errorDisplay .okButtonContainer {\n  margin-top: 2rem;\n  width: 12rem;\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n  align-items: center;\n}\n\n.error .errorImageContainer {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.docDeleteError {\n  color: red;\n  width: 98%;\n  font-size: 15px;\n  font-weight: bold;\n  padding: 10px 10px 10px 10px;\n  margin-bottom: 15px;\n  margin-top: 20px;\n  background-color: white;\n}\n#viewDeleteDocumentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tr\n  th\n  button {\n  background-color: #dfdfdf;\n  border: 1px #dedede;\n  font-weight: bold;\n}\n/*.ta .content-block .table-block .table button {\n    background-color: #ddd !important;\n}*/\n.docdelete-success {\n  margin: 26px 0px 0px 0px;\n  font-size: 15px;\n}\n\n#viewDeleteDocumentsModal .btn-cancel-action {\n  text-decoration: underline;\n  color: #76757a;\n  margin-right: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
